import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';

import enTranslation from './en.json';
import frTranslation from './fr.json';

const LANG_STORAGE_KEY = 'selectedLanguage';

const getStoredLanguage = (): string => {
    const storedLang = localStorage.getItem(LANG_STORAGE_KEY);
    return storedLang && ['en', 'fr'].includes(storedLang) ? storedLang : 'en';
};

const resources = {
    en: {
        translation: enTranslation,
    },
    fr: {
        translation: frTranslation,
    },
};

i18n
    .use(HttpApi)
    .use(initReactI18next)
    .init({
        resources,
        lng: getStoredLanguage(),
        fallbackLng: 'en',
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        returnEmptyString: false,
        saveMissing: false,
    });

export default i18n;